import React, { useEffect, useRef, useState } from "react";

import { motion, AnimatePresence } from "motion/react";
import { StatListItem } from "./statsListItem";

export const StatList = ({ rank, type, data }) => {
  var list = [];

  if (type == "artists" && data.top_artists) {
    list = data.top_artists ? data.top_artists.slice(0, 5) : [];
  } else if (type == "albums" && data.top_albums) {
    list = data.top_albums ? data.top_albums.slice(0, 5) : [];
  } else if (type == "songs" && data.top_songs) {
    list = data.top_songs ? data.top_songs.slice(0, 5) : [];
  } else if (type == "genres" && data.top_genres) {
    list = data.top_genres ? data.top_genres.slice(0, 5) : [];
  }

  return (
    <motion.div className="column-layout stats-list">
      {list.map((item, index) => (
        <StatListItem
          key={"list-item-" + index}
          rank={"" + (index + 1)}
          type={type}
          data={item}
        />
      ))}
    </motion.div>
  );
};
